import { render, staticRenderFns } from "./SupplierRawMaterialStorageShelfLife.vue?vue&type=template&id=fb9a37f8&scoped=true&"
import script from "./SupplierRawMaterialStorageShelfLife.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialStorageShelfLife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9a37f8",
  null
  
)

export default component.exports